import Slider from "react-slick";
import React, { useRef } from "react";

import { Button } from "@/components/ui/Button/Button";

import TutorialDrafting from "../assets/images/Tutorial-Drafting.png";
import TutorialRedlining from "../assets/images/Tutorial-Redlining.png";
import TutorialIntegration from "../assets/images/Tutorial-Integration.png";
import TutorialRevolutionize from "../assets/images/Tutorial-Revolutionize.png";

const TutorialPage = ({ onSkip }) => {
  var settings = {
    dots: true,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 1,
  };
  let sliderRef = useRef(null);
  return (
    <>
      <div className="flex justify-end px-8">
        <button className="py-4 text-md" onClick={onSkip} type="button">
          Skip
        </button>
      </div>
      <Slider
        ref={(slider) => {
          sliderRef = slider;
        }}
        {...settings}
      >
        <TutorialContainer
          buttonText="Next"
          desc="Leverage AI to draft and refine contract language, saving time and improving accuracy."
          img={TutorialDrafting}
          onClick={() => {
            // @ts-ignore
            sliderRef.slickNext();
          }}
          title="AI-Powered Drafting"
        />
        <TutorialContainer
          buttonText="Next"
          desc="Automatically apply AI-generated suggestions as redlines/track changes in your document."
          img={TutorialRedlining}
          onClick={() => {
            // @ts-ignore
            sliderRef.slickNext();
          }}
          title="AI-Powered Redlining"
        />
        <TutorialContainer
          buttonText="Next"
          desc="Seamlessly integrates with MS Word, allowing you to access all features without leaving your document"
          img={TutorialIntegration}
          onClick={() => {
            // @ts-ignore
            sliderRef.slickNext();
          }}
          title="Effortless Integration"
        />
        <TutorialContainer
          buttonText="Sign in"
          desc="Download Cequence Add-in and enhance your document drafting with AI-powered tools."
          img={TutorialRevolutionize}
          onClick={() => {
            onSkip();
          }}
          title="Revolutionize Your Contract Management Today"
        />
      </Slider>
    </>
  );
};

export default TutorialPage;

const TutorialContainer = ({ buttonText, desc, img, onClick, title }) => {
  return (
    <div className="text-center px-8 space-y-6">
      <img alt="placeholder" src={img} />
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="pb-4 inline-block">{desc}</p>
      {buttonText && (
        <Button className="w-full" onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};
